import { request } from '@/api/http';

/**
 * 获取统计信息
 */
export var getMenus = function getMenus() {
  return request({
    url: '/api/v5/menu/menus',
    method: 'get'
  });
};